<template>
  <div class="isolate">
    <ProductJapan v-if="isJapanProductPage" />
    <Product v-else />
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

const Product = defineAsyncComponent(
  () => import('~/scopes/product/pages/Product.vue'),
)
const ProductJapan = defineAsyncComponent(
  () => import('~/scopes/product/pages/Product-JP/Product-JP.vue'),
)

const experiments = useExperiments()
const { market } = useMarketplace()

const isJapanProductPage = computed(
  () =>
    market.countryCode === MarketCountryCode.JP &&
    experiments['experiment.ppJapanWeek'] === 'japanPP',
)
</script>
